import { useStore } from "./store/index";

import { XTXPram } from "./store/modules/XTXScoket/XTXScoket";
import { showCaDialog } from "@/utils/showCaDialog";

export interface WSResultModel {
  call_cmd_id: string;
  retVal: string;
  retValue: string;
}
export interface UkeyUserInfo {
  name: string;
  certid: string;
}

export class XTXASynObject {
  store = useStore();

  public asds: any;
  public wsObject: any;
  // 存储待处理的Promise，支持并发调用
  private pendingPromises: Map<string, { resolve: Function; reject: Function; expectedCallCmdId?: string }> = new Map();
  async initWebSocket() {
    console.log('初始化WebSocket，当前状态:', this.store.state.XTXModel.xtxScoket);
    
    if (this.store.state.XTXModel.xtxScoket == null) {
      await this.store.dispatch("XTXModel/initWebsocket");
      
      // 等待连接建立，最多等待3秒
      const maxWaitTime = 3000;
      const checkInterval = 100;
      const startTime = Date.now();
      
      while (this.store.state.XTXModel.xtxScoket == null || 
             this.store.state.XTXModel.xtxScoket.readyState !== WebSocket.OPEN) {
        if (Date.now() - startTime > maxWaitTime) {
          console.error("WebSocket连接超时，请检查证书助手环境信息！");
          showCaDialog("timeout");
          throw new Error("");
        }
        
        // 如果连接失败（CLOSED 状态），提前退出
        if (this.store.state.XTXModel.xtxScoket && 
            this.store.state.XTXModel.xtxScoket.readyState === WebSocket.CLOSED) {
          showCaDialog("failed");
          throw new Error("");
        }
        
        await new Promise(resolve => setTimeout(resolve, checkInterval));
      }
      
      console.log("WebSocket连接成功");
    }
    
    this.wsObject = this.store.state.XTXModel.xtxScoket;
    
    if (this.wsObject == null) {
      throw new Error("WebSocket对象为空，无法初始化");
    }
    
    // 每次都重新绑定消息处理器到当前实例，避免页面跳转后旧handler引用旧实例的pendingPromises
    this.wsObject._hasCustomHandler = true;
    this.wsObject.onmessage = (e: any) => {
      this.handleWebSocketMessage(e);
    };
    await this.receiveOpen();
  }
  public attachWebSocketEvent(
    eventName: string,
    eventFunc: Function,
    ws: any
  ): void {
    if (ws == null) {
      return;
    }
    ws.addEventListener(eventName.toLowerCase(), this.evalFunction(eventFunc));
  }
  public evalFunction(func: Function) {
    if (typeof func === "function") {
      return func;
    } else if (typeof func === "string") {
      return eval(func);
    } else {
      return null;
    }
  }
  // 确保 WebSocket 已初始化并连接
  async ensureWebSocketReady() {
    if (!this.wsObject || this.wsObject.readyState !== WebSocket.OPEN) {
      await this.initWebSocket();
    }
  }

  //获取用户列表
  async SOF_GetUserList() {
    await this.ensureWebSocketReady();
    const xtxPram: XTXPram = {
      callCmdId: "SOF_GetUserList",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_GetUserList",
      argsArray: [],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    var ret: any = await this.receiveMessage("SOF_GetUserList");
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    
    
    if (result.call_cmd_id == "SOF_GetUserList") {
      var ukeyList = this.setUkeyList(result.retVal);
      console.log('------获取用户列表',ukeyList);
      this.store.dispatch("XTXModel/setUserList", ukeyList);
    }
  }
  //导出用户证书
  async SOF_ExportUserCert(certId: string) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_ExportUserCert",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_ExportUserCert",
      argsArray: [certId],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //公钥加密
  async SOF_PubKeyEncrypt(cert: string, plain: string) {
    await this.ensureWebSocketReady();
    const xtxPram: XTXPram = {
      callCmdId: "SOF_PubKeyEncrypt",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_PubKeyEncrypt",
      argsArray: [cert, plain],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage("SOF_PubKeyEncrypt");
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //私钥解密
  async SOF_PriKeyDecrypt(certId: string, cipher: string) {
    await this.ensureWebSocketReady();
    const xtxPram: XTXPram = {
      callCmdId: "SOF_PriKeyDecrypt",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_PriKeyDecrypt",
      argsArray: [certId, cipher],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage("SOF_PriKeyDecrypt");
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //私钥解密（Base64明文输出）
  async SOF_PriKeyDecryptEx(certId: string, cipher: string) {
    await this.ensureWebSocketReady();
    const xtxPram: XTXPram = {
      callCmdId: "SOF_PriKeyDecryptEx",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_PriKeyDecryptEx",
      argsArray: [certId, cipher],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage("SOF_PriKeyDecryptEx");
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //导出用户加密证书
  async SOF_ExportExChangeUserCert(certId: string) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_ExportExChangeUserCert",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_ExportExChangeUserCert",
      argsArray: [certId],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage("SOF_ExportExChangeUserCert");
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //登录
  async SOF_Login(certId: string, pwd: string) {
    await this.ensureWebSocketReady();
    const xtxPram: XTXPram = {
      callCmdId: "SOF_Login",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_Login",
      argsArray: [certId, pwd],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage("SOF_Login");
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //登出
  async SOF_Logout(certId: string) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_Logout",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_Logout",
      argsArray: [certId],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage("SOF_Logout");
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //检查是否登录
  async SOF_IsLogin(certId: string) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_IsLogin",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_IsLogin",
      argsArray: [certId],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage("SOF_IsLogin");
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //获取PIN错误次数
  async SOF_GetPinRetryCount(certId: string) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_GetPinRetryCount",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_GetPinRetryCount",
      argsArray: [certId],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //修改PIN密码
  async SOF_ChangePassWd(certId: string, oldpin: string, newpin: string) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_ChangePassWd",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_ChangePassWd",
      argsArray: [certId, oldpin, newpin],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //获取文件图片
  async GetPicture(certId: string) {
    const xtxPram: XTXPram = {
      callCmdId: "GetPicture",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "GetPicture",
      argsArray: [certId],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //获取证书唯一实体标识
  async SOF_GetCertEntity(cert: string) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_GetCertEntity",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_GetCertEntity",
      argsArray: [cert],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //验证证书有效性
  async SOF_ValidateCert(cert: string) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_GetCertEntity",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_GetCertEntity",
      argsArray: [cert],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    console.log(result);
    return result.retVal;
  }
  //解析证书，具体见jsdemo
  async SOF_GetCertInfo(cert: string, type: number) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_GetCertInfo",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_GetCertInfo",
      argsArray: [cert, type],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //获取证书扩展项
  async SOF_GetCertInfoByOid(cert: string, oid: any) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_GetCertInfoByOid",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_GetCertInfoByOid",
      argsArray: [cert, oid],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //P1签名
  async SOF_SignData(certId: string, plain: string) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_SignData",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_SignData",
      argsArray: [certId, plain],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //P1验签
  async SOF_VerifySignedData(cert: string, plain: string, signature: string) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_VerifySignedData",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_VerifySignedData",
      argsArray: [cert, plain, signature],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //P1base64原文签名
  async SOF_SignDataBase64(certId: string, plain: string) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_SignDataBase64",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_SignDataBase64",
      argsArray: [certId, plain],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //P1base64原文验签
  async SOF_VerifySignedDataBase64(
    cert: string,
    plain: string,
    signature: string
  ) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_VerifySignedDataBase64",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_VerifySignedDataBase64",
      argsArray: [cert, plain, signature],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //数据签名：(颐信格式)1；数据签名(默认格式)2；
  async SOF_SignDataEx(certId: string, plain: string, signType: number) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_SignDataEx",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_SignDataEx",
      argsArray: [certId, plain, signType],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //P1base64原文验签
  async SOF_VerifySignedDataEx(
    cert: string,
    plain: string,
    signature: string,
    signType: any
  ) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_VerifySignedDataEx",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_VerifySignedDataEx",
      argsArray: [cert, plain, signature, signType],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //验证签名WithUserID
  async SOFX_VerifySignedFileWithID(
    cert: string,
    plainfile: string,
    signature: string,
    userId: string
  ) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_VerifySignedDataEx",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_VerifySignedDataEx",
      argsArray: [cert, plainfile, signature, userId],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //hash签名 algor:SM3(1) SHA1(2) SHA256(4)
  async SOF_SignHashData(certId: string, hash: string, algor: number) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_SignHashData",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_SignHashData",
      argsArray: [certId, hash, algor],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //P7签名
  async SOF_SignMessage(dwFlg: number, certId: string, plain: string) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_SignMessage",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_SignMessage",
      argsArray: [dwFlg, certId, plain],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //P7签名验签
  async SOF_VerifySignedMessage(signature: string, plain: string) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_VerifySignedMessage",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_VerifySignedMessage",
      argsArray: [signature, plain],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //P7base64签名
  async SOF_SignMessageBase64(dwFlg: number, certId: string, plain: string) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_SignMessageBase64",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_SignMessageBase64",
      argsArray: [dwFlg, certId, plain],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //P7base64签名验签
  async SOF_VerifySignedMessageBase64(signature: string, plain: string) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_VerifySignedMessageBase64",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_VerifySignedMessageBase64",
      argsArray: [signature, plain],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //解析P7签名
  async SOF_GetInfoFromSignedMessage(signature: string, item: string) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_GetInfoFromSignedMessage",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_GetInfoFromSignedMessage",
      argsArray: [signature, item],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //P7 hash 签名 algor:SM3(1) SHA1(2) SHA256(4)
  async SOF_SignHashMessage(certId: string, hash: string, algor: number) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_GetInfoFromSignedMessage",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_GetInfoFromSignedMessage",
      argsArray: [certId, hash, algor],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //验证P7 hash签名
  async SOF_VerifySignedHashMessage(signature: string, hash: string) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_VerifySignedHashMessage",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_VerifySignedHashMessage",
      argsArray: [signature, hash],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //获取签名算法
  async SOF_GetSignMethod() {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_GetSignMethod",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_GetSignMethod",
      argsArray: [],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //设置签算法见JSdemo相应选项
  async SOF_SetSignMethod(algor: number) {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_SetSignMethod",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_SetSignMethod",
      argsArray: [algor],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //获取加密算法
  async SOF_GetEncryptMethod() {
    const xtxPram: XTXPram = {
      callCmdId: "SOF_GetEncryptMethod",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_GetEncryptMethod",
      argsArray: [],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //设置加密算法见JSdemo相应选项
  async SOF_SetEncryptMethod(algor: number) {
    await this.ensureWebSocketReady();
    const xtxPram: XTXPram = {
      callCmdId: "SOF_SetEncryptMethod",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_SetEncryptMethod",
      argsArray: [algor],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage("SOF_SetEncryptMethod");
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //生成随机数（用于生成对称密钥）
  async SOF_GenRandom(randomLen: number) {
    await this.ensureWebSocketReady();
    const xtxPram: XTXPram = {
      callCmdId: "SOF_GenRandom",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_GenRandom",
      argsArray: [randomLen],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //对称加密数据
  async SOF_SymEncryptData(key: string, data: string) {
    await this.ensureWebSocketReady();
    const xtxPram: XTXPram = {
      callCmdId: "SOF_SymEncryptData",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_SymEncryptData",
      argsArray: [key, data],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage("SOF_SymEncryptData");
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //对称解密数据
  async SOF_SymDecryptData(key: string, encryptedData: string) {
    await this.ensureWebSocketReady();
    const xtxPram: XTXPram = {
      callCmdId: "SOF_SymDecryptData",
      clsid: XTXSyncModel.xtxClsid,
      methodName: "SOF_SymDecryptData",
      argsArray: [key, encryptedData],
    };
    this.store.dispatch("XTXModel/webSocketCall", xtxPram);
    let ret: any = await this.receiveMessage();
    var result: WSResultModel;
    result = JSON.parse(ret.data);
    return result.retVal;
  }
  //设置配置参数见JSdemo
  // async SetUserConfig(type:number,value:any){
  //     const xtxPram: XTXPram = {
  //         callCmdId: "SetUserConfig",
  //         clsid: XTXSyncModel.xtxClsid,
  //         methodName: "SetUserConfig",
  //         argsArray: [type,value]
  //     }
  //     this.store.dispatch('XTXModel/webSocketCall', xtxPram);
  //     let ret: any = await this.receiveMessage();
  //     var result: WSResultModel;
  //     result = JSON.parse(ret.data);
  //     return result.retVal;
  // }
  //设置用户列表
  setUkeyList(strUserList: string): Array<UkeyUserInfo> {
    let list = new Array<UkeyUserInfo>();
    if (strUserList != null || strUserList != "") {
      var userList: string[] = strUserList.split("&&&");
      for (var i = 0; i < userList.length; i++) {
        if (userList[i] != null && userList[i] != "") {
          var user: string[] = userList[i].split("||");
          let info: UkeyUserInfo = { name: user[0], certid: user[1] };
          list.push(info);
        }
      }
    }
    return list;
  }

  receiveOpen() {
    return new Promise((resolve, reject) => {
      // 如果已经连接，直接执行
      if (this.wsObject && this.wsObject.readyState === WebSocket.OPEN) {
        this.SOF_GetUserList();
        resolve(true);
        return;
      }
      
      // 如果连接已关闭或失败，拒绝
      if (this.wsObject && this.wsObject.readyState === WebSocket.CLOSED) {
        reject(new Error("WebSocket连接已关闭"));
        return;
      }
      
      // 等待连接打开
      const timeout = setTimeout(() => {
        reject(new Error("等待WebSocket连接超时"));
      }, 3000);
      
      this.wsObject.onopen = (e: any) => {
        clearTimeout(timeout);
        this.SOF_GetUserList();
        resolve(true);
      };
    });
  }
  receiveMessage(expectedCallCmdId?: string) {
    return new Promise((resolve, reject) => {
      // 注册到待处理队列，使用 expectedCallCmdId 作为 key（如果提供）
      const callId = expectedCallCmdId || `any_${Date.now()}_${Math.random()}`;
      this.pendingPromises.set(callId, { resolve, reject, expectedCallCmdId });
      
      // 确保消息处理器绑定到当前实例
      if (this.wsObject) {
        this.wsObject._hasCustomHandler = true;
        this.wsObject.onmessage = (e: any) => {
          this.handleWebSocketMessage(e);
        };
      }
    });
  }

  // 统一处理WebSocket消息
  private handleWebSocketMessage(e: any) {
    let result: WSResultModel;
    try {
      result = JSON.parse(e.data);
    } catch (err) {
      console.error('解析WebSocket消息失败:', e.data);
      return;
    }

    // 处理USBKey变化通知
    if (result.call_cmd_id == "onUsbkeyChange") {
      this.SOF_GetUserList();
      return;
    }

    // 处理用户列表更新（广播消息）
    if (result.call_cmd_id == "SOF_GetUserList") {
      var ukeyList = this.setUkeyList(result.retVal);
      this.store.dispatch("XTXModel/setUserList", ukeyList);
    }

    // 查找并处理对应的pending promise
    // 1. 先尝试精确匹配 call_cmd_id
    const pending = this.pendingPromises.get(result.call_cmd_id);
    if (pending) {
      this.pendingPromises.delete(result.call_cmd_id);
      pending.resolve(e);
      return;
    }
    
    // 2. 如果没有精确匹配，找第一个等待任意响应的pending promise
    let foundAny = false;
    this.pendingPromises.forEach((value, key) => {
      if (!foundAny && !value.expectedCallCmdId) {
        // 这个promise接受任意响应
        foundAny = true;
        this.pendingPromises.delete(key);
        value.resolve(e);
      }
    });
  }
  cellMsgMethod = (e: any) => {
    var result: WSResultModel;
    result = JSON.parse(e.data);
    if (result.call_cmd_id == "onUsbkeyChange") {
      this.SOF_GetUserList();
    } else {
      if (result.call_cmd_id == "SOF_GetUserList") {
        var ukeyList = this.setUkeyList(result.retVal);
        this.store.dispatch("XTXModel/setUserList", ukeyList);
      }
    }
  };
  constructor() {
    // 不在构造函数中自动初始化，改为在使用时按需初始化
    // 这样可以避免在组件创建时立即尝试连接，而是在真正需要时才连接
  }
}

class XTXSyncModel {
  static xtxClsName: string = "XTXAppObj";
  static xtxClsid: string = "3F367B74-92D9-4C5E-AB93-234F8A91D5E6";
  static picClsName: string = "GetPicObj";
  static picClsid: string = "3BC3C868-95B5-47ED-8686-E0E3E94EF366";
  static xtxVersionClsid: string = "574887FB-22A5-488B-A49C-2CF25F56BE68";
}
